import { Label } from '@cluey/cluey-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const FieldLabel = ({ id, labelText, className }) => {
  return (
    <Label id={id} size="base" className={classNames('mb-1 inline-block font-body font-medium', className)}>
      {labelText}
    </Label>
  );
};

FieldLabel.propTypes = {
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default FieldLabel;
